<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn v-if="barVis" icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">
        历史记录
        <span v-if="camName"> - {{camName}}</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-content style="background: #eee;">
      <v-container style="padding:0;padding-bottom:4rem;">
        <div v-if="loading" style="margin-top:10rem;">
          <LoadingText />
        </div>
        <div v-else>
          <div v-if="list.length > 0" style="color:#fff;padding:0.5rem;">
            <div v-for="(item,index) in list" :key="index">
              <NotifyCard :item="item" flat />
            </div>
          </div>
          <div v-if="list.length === 0" style="text-align:center;margin-top:10rem;color:#9e9e9e;font-size:0.8rem;">
              暂无记录
          </div>
          <div v-else>
            <div style="text-align:center;margin:1.7rem 0 0.5rem;" v-if="hasMore">
              <v-btn color="primary" style="width:10rem;" @click="clickLoadMore">加载更多</v-btn>
            </div>
            <div v-else style="text-align:center;font-size:0.8rem;color:#9e9e9e;margin-top:1.7rem;">
              没有更多数据!
            </div>
          </div>
        </div>
        <div class="us-create-btn" @click="dialogVis = true">
          <v-btn dark fab right color="#5cbbf6"><v-icon>mdi-magnify</v-icon></v-btn>
        </div>
        <NotifyDialog ref="notify_dialog" :visible.sync="dialogVis" @search="search" />
      </v-container>
    </v-content>
  </v-app>

</template>

<script>
import LoadingText from '../../components/LoadingText'
import NotifyCard from './components/NotifyCard.vue'
import NotifyDialog from './components/NotifyDialog.vue'
export default {
  components: { LoadingText, NotifyCard, NotifyDialog },
  props: {
  },
  data() {
    return {
      loading: true,
      list: [],
      pageIndex: 1,
      pageCount: 10,
      hasMore: true,
      dialogVis: false,
      listFilter: {
        create_time: [],
        peccancy_type: '',
        run_type: '',
        car_no: '',
        seq_code: '',
        dept: '',
        us_text: '',
        car_type: '',
        car_no_color: '',
        car_color: ''
      },
      camName: '',
      barVis: false
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  activated() {
    var that = this
    that.$store.commit('SET_FNAVVAL', 2)
    that.init()
    if (that.$route.query.seq_code) {
      that.listFilter.seq_code = that.$route.query.seq_code
    }
    if (that.$route.query.cam_name) {
      that.camName = that.$route.query.cam_name
    }

    var type = that.$route.query.type
    if (type) {
      if (type === 1) {
        that.listFilter.peccancy_type = '正常'
        that.camName = '正常'
      } else if (type === 2) {
        that.listFilter.peccancy_type = '超速'
        that.camName = '超速'
      }
    }
    if (!that.$router.isBack) {
      that.setDialogData()
    }
    that.getList()
  },
  methods: {
    init() {
      var that = this
      that.barVis = false
      that.listFilter = {
        create_time: [],
        peccancy_type: '',
        run_type: '',
        car_no: '',
        seq_code: '',
        dept: '',
        us_text: '',
        car_type: '',
        car_no_color: '',
        car_color: ''
      }
      that.camName = ''

      var starttime = that.$moment().startOf('month').format('YYYY-MM-DD')
      var endtime = that.$moment().endOf('month').format('YYYY-MM-DD') // 下个月末

      that.create_time = [starttime, endtime]

      that.list = []
      that.pageIndex = 1
      that.pageCount = 10
    },
    goBack() {
      this.$router.goBack()
    },
    async getList() {
      var that = this
      if (that.pageIndex === 1) {
        that.list = []
        that.loading = true
      }
      // var res = await that.$api.bz.queryCamImageList({ page_index: that.pageIndex, page_count: that.pageCount })
      var res = await that.$api.bz.queryCamImageList({ page_index: that.pageIndex, page_count: that.pageCount, str_filter: JSON.stringify(that.listFilter) })
      if (!res.success) {
        console.log('获取列表失败', res);
        that.loading = false
        return;
      }
      var data = res.data
      if (data.length == 0) {
        that.loading = false
        that.hasMore = false;
        return;
      }
      that.hasMore = data.length >= that.pageCount;
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        that.list.push(item);
      }
      that.loading = false
    },
    clickLoadMore() {
      var that = this
      that.pageIndex++;
      that.getList();
    },
    search(obj) {
      var that = this
      that.listFilter = obj
      that.pageIndex = 1
      that.pageCount = 10
      that.getList()
    },
    setDialogData() {
      var that = this
      that.$refs.notify_dialog.setData(that.listFilter)
    }
  }
}
</script>

<style scoped>
.us-v-badge >>> .v-badge__badge{
  height: 5px !important;
  width: 5px !important;
}

.us-list-item >>> .v-list-item__icon{
  min-width: 0.9rem;
}
.us-create-btn{
  position:fixed;
  bottom: 4rem;
  right: 1.5rem;
}
</style>

